<ng-container *ngFor="let airComponent of AirComponentType | enumToArray">
  <button [ngClass]="!isDisabled && selectedAirComponent === airComponent ? '__component-button--selected' : '__component-button'"
          [style.cursor]="isDisabled ? 'initial' : 'pointer'"
          (click)="onSelectAirComponent(airComponent)">
    {{airComponent | sensorHeader}}
  </button>
</ng-container>
